import {  MouseEvent } from 'react';

// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
// import { Card,  Logout, Profile } from 'iconsax-react';
import {
  // CallCalling,
  // ClipboardTick,
  // Lock,
  // MoneySend,
  Profile,
  Logout,
  // BrifecaseTimer
  // UserEdit
} from 'iconsax-react';
import { useNavigate ,useLocation} from 'react-router-dom';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  handleLogout: () => void;
}

const ProfileTab = ({ handleLogout }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();  
  const handleListItemClick = (event: MouseEvent<HTMLDivElement>, index: number,nav:string) => {

    navigate(nav);
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>

      {/* <ListItemButton selected={location.pathname=='/profile/my-attendance'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1,'/profile/my-attendance')}>
        <ListItemIcon>
          <ClipboardTick variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Attendance" />
      </ListItemButton>

      <ListItemButton selected={location.pathname=='/profile/my-tasks'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1,'/profile/my-tasks')}>
        <ListItemIcon>
          <BrifecaseTimer variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Tasks" />
      </ListItemButton>

      <ListItemButton selected={location.pathname=='/profile/my-follow-ups'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1,'/profile/my-follow-ups')}>
        <ListItemIcon>
          <CallCalling variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Follow Ups" />
      </ListItemButton>

      <ListItemButton selected={location.pathname=='/profile/my-expenses'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 3,'/profile/my-expenses')}>
        <ListItemIcon>
          <MoneySend variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Expenses" />
      </ListItemButton>
      <ListItemButton selected={location.pathname=='/profile/my-leave-applications'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 4,'/profile/my-leave-applications')}>
        <ListItemIcon>
          <ClipboardTick variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Leaves" />
      </ListItemButton> */}
      
      <ListItemButton selected={location.pathname=='/profile'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0,'/profile')}>
        <ListItemIcon>
          <Profile variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItemButton>
      
      <ListItemButton selected={location.pathname=='/profile/my-change-password'} onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0,'/profile/change-password')}>
        <ListItemIcon>
          <Profile variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Change Password" />
      </ListItemButton>
      <ListItemButton selected={false} onClick={handleLogout}>
        <ListItemIcon>
          <Logout variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
